export const stepConfig = [
  {target: '.createLessonButton', key: 'createLesson'},
  {target: '.LessonOptions', key: 'kebabMenu'},
];
